import { TxpEventTypes } from 'owa-calendar-configuration/lib/store/schema/TxpGriffinSettingsPayload';
import { TxpSettingsDialogViewState } from '../../store/viewSchema/TxpSettingsDialogViewState';
import { TxpEventFlagsV2 } from 'owa-txp-option/lib/utils/getTxpFlagInfo';

export default function getTxpGriffinSettingsPayloadFromEntitySetting(
    eventType: TxpEventFlagsV2,
    value: number
) {
    if (eventType && value !== null && value !== undefined) {
        const entitySettings: TxpEventTypes = {
            FlightReservation: undefined,
            FoodEstablishmentReservation: undefined,
            LodgingReservation: undefined,
            RentalCarReservation: undefined,
            ParcelDelivery: undefined,
            EventReservation: undefined,
            Invoice: undefined,
            ServiceReservation: undefined,
        };

        const viewState: TxpSettingsDialogViewState = {
            txpSettings: {
                EntityTypeProcessorLevelSettings: entitySettings,
                CreateEventsFromEmailAsPrivate: undefined,
            },
        };

        entitySettings[eventType] = value;

        return viewState;
    }

    return null;
}
